var is_full = window.matchMedia('all and (min-width: 1679px)').matches;
var is_md = window.matchMedia('all and (max-width: 1679px) and (min-width: 1199px)').matches;
var is_sd = window.matchMedia('all and (max-width: 1199px) and (min-width: 1023px)').matches;

var is_desktop = window.matchMedia('all and (min-width: 1023px)').matches;

var is_tablet = window.matchMedia('all and (max-width: 1023px)').matches;
var is_tablet_big = window.matchMedia('all and (min-width: 1023px) and (max-width: 1026px)').matches;
var is_tablet_only = window.matchMedia('all and (min-width: 767px) and (max-width: 1023px)').matches;
var is_mobile = window.matchMedia('all and (max-width: 700px)').matches;
var is_retina = window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (min--moz-device-pixel-ratio: 1.5), only screen and (-o-min-device-pixel-ratio: 3/2), only screen and (min-resolution: 1.5dppx), only screen and (min-resolution: 144dpi)').matches;

$(function () {
	var scrollbar;
	if (!is_mobile && !is_tablet && !is_tablet_big && !$('#wrapper').hasClass('front_page')) {
		console.log('scrollbar init')
		scrollbar = Scrollbar.init(
			document.querySelector("#main-content"),
			{
				damping: 0.07
			}
		);

		scrollbar.addListener(function (status) {
			scroll_init(status.offset.y);

			lazy_load(status.offset.y);
			scroll_service_init($(window), false);
			svg_init(status.offset.y);
		});
	}

	adaptive_video_init();

	//Кастомизация чекбоксов
	init_checkbox_style();
	init_radio_style();


	$('input[type=tel]').mask('+7 (999) 999-99-99');

	//Accordion
	$('.accordion-img-itm').on('click', function () {
		if ($(this).hasClass('active')) {
			return true;
		}

		$(this).siblings().removeClass('active');
		$(this).addClass('active');

		let content = $(this).find('.accordion-img-itm__content'),
			content_prev = $(this).siblings().find('.accordion-img-itm__content');

		let tl = gsap.timeline();

		tl.to(content_prev, {
			height: '0px',
			opacity: 0,
			y: 20,
			duration: .3,
			ease: 'Sine.easeOut'
		});

		tl.to($(this).siblings(), {
			height: '20%',
			duration: .3,
			ease: 'Sine.easeOut'
		}, '<');

		if (is_tablet) {
			tl.to($(this).siblings().find('.accordion-img-itm__name'), {
				height: '40px',
				duration: .3,
				ease: 'Sine.easeOut'
			}, '<');

			tl.to($(this).find('.accordion-img-itm__name'), {
				height: 'auto',
				duration: .3,
				ease: 'Sine.easeOut'
			}, '<');

		}


		tl.to(content, {
			height: 'auto',
			duration: .3,
			ease: 'Sine.easeOut'
		}, '<');

		tl.fromTo(content, {
			opacity: 0,
			y: 20
		}, {
			y: 0,
			opacity: 1,
			duration: .3,
			ease: 'Sine.easeOut'
		}, 0.3);

		gsap.to($(this), {
			height: '40%',
			duration: .3,
			ease: 'Sine.easeOut'
		});


	});

	gsap.to($('.accordion-img-itm.active .accordion-img-itm__content'), {
		height: 'auto',
		opacity: 1,
		transform: 'translateY(0px)',
		duration: 0
	});
	gsap.to($('.accordion-img-itm.active'), {
		height: '40%',
		duration: 0
	});

	$(window).on('resize', function () {
		let is_tablet_old = is_tablet;
		let is_desktop_old = is_desktop;

		is_full = window.matchMedia('all and (min-width: 1679px)').matches;
		is_md = window.matchMedia('all and (max-width: 1679px) and (min-width: 1199px)').matches;
		is_sd = window.matchMedia('all and (max-width: 1199px) and (min-width: 1023px)').matches;
		is_tablet = window.matchMedia('all and (max-width: 1023px)').matches;
		is_tablet_only = window.matchMedia('all and (min-width: 767px) and (max-width: 1023px)').matches;
		is_mobile = window.matchMedia('all and (max-width: 700px)').matches;
		is_desktop = window.matchMedia('all and (min-width: 1023px)').matches;


		if ((!is_tablet_old) && (is_tablet) || (!is_desktop_old) && (is_desktop)) {
			window.location.reload();
		}
	});

	$('.js-sequence-mouse').on('mousemove', function (e) {
		let x = e.clientX,
			max_x = $(this).outerWidth(true),
			sequence = $('.front-sequence .front-sequence__img, .js-sequence-target');

		sequence.each(function () {
			let sequence_img = $(this).find('img'),
				frame = sequence_img.length,
				frame_step_width = max_x / (frame - 1),
				active_frame = Math.round(x / frame_step_width);

			if (active_frame > frame) {
				active_frame = frame;
			}

			sequence_img.removeClass('active');
			sequence_img.eq(active_frame).addClass('active')
		});

	});

	$(document).on('click', '.js-ajax-modal', function () {
		let href = $(this).attr('href'),
			action = $(this).attr('data-action'),
			id = $(this).attr('data-id'),
			modal_type = $(this).attr('data-modal-type');

		if (action) {
			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				type: 'POST',
				data: {
					'action': action,
					'post_id': id,
				},
				success: function (response) {
					var html = response.substr(0, response.length - 1);

					show_modal(html);
					$('.modal').addClass(modal_type);
					setTimeout(function () {
						svg_init();
					}, 100);
				}
			});
		} else {
			$.ajax({
				url: href,
				dataType: 'html',
				cache: false,
				success: function (data) {
					show_modal(data);
					$('.modal').addClass(modal_type);
					setTimeout(function () {
						svg_init();
					}, 100);
				}
			});
		}

		return false;
	});

	$(document).on('click', '.modal-fade,.js-close-modal', function () {
		var modal = $(this).closest('.modal');

		gsap.to(modal.find('.modal-content'), {opacity: 0, y: 50, duration: 0.3}).then(function () {
			modal.remove();
		});
		gsap.to(modal, {opacity: 0, duration: .8}).then(function () {
			modal.remove();
		});

		bodyUnLock();

		return false;
	});

	$(window).on('scroll', function () {
		scroll_init($(window).scrollTop());
	});

	$('body').on('scroll', function () {
		scroll_init($('body').scrollTop());
	});

	$('.js-scroll-top').on('click', function () {
		$('html, body').animate({scrollTop: 0}, 1000);

		scrollbar.scrollTo(0, 0, 600)

	});

	scroll_init($(window).scrollTop());

	if ($('.client-list').length > 0 && !is_tablet) {
		$('.client-list').owlCarousel({
			items: 3,
			slideBy: 3,
			loop: true,
			margin: 64,
			nav: true,
			smartSpeed: 250,
			dots: false,
			slideTransition: "cubic-bezier(0.65,0.05,0.36,1)",
			responsive: {
				0: {
					items: 1.7,
					margin: 8,
					nav: false
				},
				1023: {
					margin: 26,
				},
				1281: {
					margin: 40,
				}
			}
		});
	}


});

function scroll_init(scroll) {

	if ($('.fp-enabled').length > 0 && is_tablet_big) {
		return false;
	}

	if (scroll > 1500) {
		$('.scroll-top').addClass('show');
	} else {
		$('.scroll-top').removeClass('show');
	}
	if (scroll > 10) {
		$('.order-fixed-btn').addClass('text-hide');

		if ($('.header-menu').hasClass('active') || is_tablet) {
			close_header_menu();
		}
	} else {
		$('.order-fixed-btn').removeClass('text-hide');

		if (!$('.header-menu').hasClass('active') || is_tablet) {
			open_header_menu();
		}
	}
}

function adaptive_video_init() {
	var video = $('.js-adaptive-video');

	if (video.length === 0) {
		return false;
	}

	if (is_tablet) {
		console.log(video.attr('data-src-mobile'))
		video.attr('src', video.attr('data-src-mobile'));
	} else {
		video.attr('src', video.attr('data-src'));
	}

}

function bodyLock() {
	if (is_tablet) {
		$('body, html').addClass("fixed");
	}
	/*const lockPaddingValue = window.innerWidth - $('.wrapper')[0].offsetWidth + 'px';

	$('body, .header, .order-fixed-block,.wrapper-line,.modal,.preloader').css('padding-right', lockPaddingValue);
	$('body').addClass('fixed');
	$('.wrapper').addClass('show-modal');*/
}

function bodyUnLock() {
	$('body, html').removeClass("fixed");

	/*$('body, .header, .order-fixed-block,.wrapper-line,.modal,.preloader').css('padding-right', '0px');
	$('body').removeClass('fixed');
	$('.wrapper').removeClass('show-modal');*/
}

function init_radio_style() {
	$('input.js-radio').each(function () {
		if (!$(this).parent().is('.radio_box')) {
			var placeholder = $(this).attr('placeholder');

			$(this).wrap('<label class="radio_box"></label>');
			$(this).after('<span class="radio_box__item"></span><span class="radio_box__text">' + placeholder + '</span>');
		}

		if ($(this).prop('checked')) {
			$(this).parent('.radio_box').addClass('checked');
		} else {
			$(this).parent('.radio_box').removeClass('checked');
		}
	});

};

function show_modal(content) {
	$('.modal').remove();
	$('.wrapper').append('<div class="modal"><div class="modal-fade"></div><div class="modal-content"><a href="#" class="js-close-modal close-modal"><span class="cross"></span></a>' + content + '</div></div>');

	gsap.fromTo($('.modal-fade'), {opacity: 0}, {opacity: 0.95});
	gsap.fromTo($('.modal-content'), {opacity: 0, y: 50}, {opacity: 1, y: 0, duration: .3}).delay(.25);

	bodyLock();
	$('input[type=tel]').mask('+7 (999) 999-99-99');

}

function init_checkbox_style() {
	$('input.js-checkbox').each(function () {
		if (!$(this).parent().is('.check_box')) {
			var placeholder = $(this).attr('placeholder');

			$(this).wrap('<label class="check_box"></label>');
			$(this).after('<span class="check_box__item"></span><span class="check_box__text">' + placeholder + '</span>');
		}

		if ($(this).prop('checked')) {
			$(this).parent('.check_box').addClass('checked');
		} else {
			$(this).parent('.check_box').removeClass('checked');
		}
	});
};